import React from 'react';
import ManualReviewQueueSection from '../../../sections/AdminDashboard/Moderation/ManualReviewQueue';

const AdminManualReviewQueue = () => {
  return <ManualReviewQueueSection />;
};

export default AdminManualReviewQueue;

